/**
 * <TutorStudentsSkeleton> — « Mes élèves » pendant son premier chargement.
 *
 * Le titre, qui ne dépend d'aucune donnée, la place des deux gestes de la barre de titre, puis
 * trois lignes d'élève dans la carte-liste (`<TutorStudentRowSkeleton>`).
 */
import React from "react"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Title } from "../../atoms/typography/Title"
import { CardList } from "../../molecules/CardList"
import { REFRESH_BUTTON_SIZE } from "../../molecules/RefreshButton"
import { TutorStudentRowSkeleton } from "../../organisms/TutorStudentRow"

export function TutorStudentsSkeleton() {
    return (
        <Stack gap="4">
            <Row justify="between" align="center">
                <Title size="text-2xl">Mes élèves</Title>
                <Row gap="1" align="center">
                    <Skeleton shape="block" width={96} height={pushButtonBoxHeight("sm")} />
                    <Skeleton shape="circle" size={REFRESH_BUTTON_SIZE} />
                </Row>
            </Row>
            <CardList>
                <TutorStudentRowSkeleton />
                <TutorStudentRowSkeleton />
                <TutorStudentRowSkeleton />
            </CardList>
        </Stack>
    )
}
